import nmImgOne from "../../../img/portfolio/new-movements/nm-optimized.jpg";
import nmImgTwo from "../../../img/portfolio/new-movements/nm-2-optimized.jpg";
import nmImgThree from "../../../img/portfolio/new-movements/nm-3-optimized.jpg";
import nmImgFour from "../../../img/portfolio/new-movements/nm-4-optimized.jpg";
import nmImgFive from "../../../img/portfolio/new-movements/nm-5-optimized.jpg";
import nmImgSix from "../../../img/portfolio/new-movements/nm-6-optimized.jpg";
import nmImgSeven from "../../../img/portfolio/new-movements/nm-7-optimized.jpg";
import nmImgEight from "../../../img/portfolio/new-movements/nm-8-optimized.jpg";
import nmImgNine from "../../../img/portfolio/new-movements/nm-9-optimized.jpg";
import nmImgTen from "../../../img/portfolio/new-movements/nm-10-optimized.jpg";
import nmImgEleven from "../../../img/portfolio/new-movements/nm-11-optimized.jpg";
import nmImgTwelve from "../../../img/portfolio/new-movements/nm-12-optimized.jpg";

const nmImagesArray = [
    nmImgOne,
    nmImgTwo,
    nmImgThree,
    nmImgFour,
    nmImgFive,
    nmImgSix,
    nmImgSeven,
    nmImgEight,
    nmImgNine,
    nmImgTen,
    nmImgEleven,
    nmImgTwelve
]

export default nmImagesArray;